import { useEffect } from 'react';

/**
 * Sets the document title to the given string. Restores the previous
 * document title when the component unloads.
 * @param title The document title to use. This can be derived from React state,
 * and the document title will be kept up-to-date with stateful titles.
 */
export function useTitle(title: string): void {
    useEffect(() => {
        const prevTitle = document.title;
        document.title = title;
        return () => {
            document.title = prevTitle;
        };
    }, [title]);
}
